import React, { useEffect, useCallback } from 'react';
import { Route, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import ErrorBoundary from '../../components/error-boundary';
import { PlanFeaturesTrialUpsellBanner } from '../../components/plan-features-trial-upsell-banner';
import { BannerSources } from '../../components/plan-features-trial-upsell-banner/constants';
import gridPageStyle from '../grid-page.module.less';
import { ReturnsGridContainer } from '../../containers/returns-grid-container';
import { ReturnsGridPagingControlContainer } from '../../containers/returns-grid-paging-control-container';
import ReturnsStatusTabs from '../../components/returns-status-tabs';
import ReturnPageHeader from '../../components/returns-page-header/index';
import { ReturnsFilterBarContainer } from '../../containers/returns-filter-bar-container';
import ReturnsEditColumnsButtonContainer from '../../components/edit-columns-button/containers/returns-grid-container';
import { ReturnModalLoader } from '../../components/modals/return-details-modal/return-modal-loader';
import { resolveRoute } from '../../services/return-details-route-resolver';
import { useIsOnReturnsAdvancedSearchView } from '../../advanced-search/hooks';
import Global from '../../store/global-selectors';
import * as NavActions from '../../store/returns/nav/returns.nav.actions';
import { useFirstDefaultRouteWithPermissions } from '../../hooks/use-first-default-route-with-permissions';
import { getReturnsPageStatusPath } from '../../store/returns/returns.helpers';
import { EnhancedReturnsPromotionalBanner } from './returns-promotional-banner';

import style from './returns-page.module.less';

export const LegacyReturnsContent = () => {
  const match = useRouteMatch();
  const { history } = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isLoading = useSelector(Global.selectReturnsGridIsLoading);
  const defaultRouteWithPerms = useFirstDefaultRouteWithPermissions();
  const selectedTab = getReturnsPageStatusPath(pathname, true);

  const goToDefaultPage = useCallback(() => {
    history.push(defaultRouteWithPerms);
  }, [history, defaultRouteWithPerms]);

  useEffect(() => {
    dispatch(NavActions.changeView(selectedTab, false));
    dispatch(NavActions.returnsViewsChanged());
  }, [selectedTab, dispatch]);

  const isOnAdvancedSearch = useIsOnReturnsAdvancedSearchView();

  return (
    <div className={gridPageStyle['main-content']}>
      <div className={gridPageStyle['grid-header']}>
        <ReturnPageHeader
          bannerSlot={
            <PlanFeaturesTrialUpsellBanner className={style['plan-features-trial-upsell-banner']} source={BannerSources.Returns} />
          }
        />
        <div className={style['edit-columns-button-container']}>
          <ReturnsEditColumnsButtonContainer />
        </div>
      </div>
      <EnhancedReturnsPromotionalBanner />
      <div className={gridPageStyle['edit-grid-wrap']}>
        <div>{!isOnAdvancedSearch && <ReturnsStatusTabs />}</div>
        <div className={gridPageStyle['grid-filter-wrap']}>{!isOnAdvancedSearch && <ReturnsFilterBarContainer />}</div>
      </div>
      <div className={gridPageStyle['grid-content']}>
        {isLoading && <LoadingIndicator />}
        {!isLoading && (
          <div className={classnames(gridPageStyle['grid-and-footer'], gridPageStyle['no-sidebar'])}>
            <div className={gridPageStyle.grid}>
              <ErrorBoundary errorMessageId='returnsGrid' onError={goToDefaultPage}>
                <ReturnsGridContainer />
              </ErrorBoundary>
            </div>
            <div className={[gridPageStyle['paging-footer']]}>
              <ReturnsGridPagingControlContainer />
            </div>
          </div>
        )}
      </div>
      <Route component={ReturnModalLoader} path={resolveRoute(match.url)} />
      <Route component={ReturnModalLoader} path={`${match.url}/enhanced-return/:fulfillmentId`} />
    </div>
  );
};
